import {useTranslation} from "react-i18next";

function TagsContent(props) {
  const { t } = useTranslation();
  const { user, openPopup, errors, register,
          selected_geo, selected_themes, selected_contacts, selected_entities,
	  confidential_forced } = props;

  return (
    <>
      <div className="c-write tags">
        <div className="c-write_header">
          <span className="c-header_number">3</span>
          <p className="c-header_title">
            {user.confidential_access ? t('Lier des tags et choisir le niveau de confidentialité') : t('Lier des tags')}
          </p>
        </div>
        <div className="c-write_content">
          <div className="c-content_geos">
            <p>{t('Localisation')}</p>
            <span onClick={() => openPopup("geo")} {...register("poi_geo_id", { required : true})} >
              {selected_geo.item || `${t('Aucune localisation sélectionnée')}`}
            </span>
            {errors.poi_geo_id && <div className="c-errors">{t('Une localisation est obligatoire')}</div>}
        </div>
          <div className="c-content_themes">
            <p>{t('Thèmes')}</p>
            <span onClick={() => openPopup("theme")}>{selected_themes.length} {t('sélectionné(s)')}</span>
          </div>
          <div className="c-content_contacts">
            <p>{t('Contacts')}</p>
            <span onClick={() => openPopup("contact")}>{selected_contacts.length} {t('sélectionné(s)')}</span>
          </div>
          <div className="c-content_entities">
            <p>{t('Entités')}</p>
            <span onClick={() => openPopup("entity")}>{selected_entities.length} {t('sélectionné(s)')}</span>
          </div>
        </div>
      </div>

      { user.has_confidential_access &&
      <div className="c-write confidentiality">
        <div className="c-write_content" style={{"justifyContent": "center"}}>
	  <div className="c-content_confidentiality">
	    <p>{t('Confidentialité')}</p>
	    <div className="c-content_choices">
	      <div className="c-content_card one" style={confidential_forced ? {display: "none"} : {}}>
		<div className="c-card_header">
		  <span className="c-card_title">{t('Public')}</span>
		  <input type="radio" name="checkbox" value="false" {...register("confidential", { required : true})}/>
		</div>
		<p className="c-card_content">{t('text_editor_public')}</p>
	      </div>
	      <div className="c-content_card two">
		<div className="c-card_header">
		  <span className="c-card_title">{t('Confidential')}</span>
		  <input type="radio" name="checkbox" value="true" {...register("confidential", { required : true})}/>
		</div>
		<p className="c-card_content">
		  {t('text_editor_confidential')}
		  { confidential_forced && <div style={{marginTop: "10px", fontSize: "14px"}}>
		      {"(" + t('text_editor_confidential_forced') + ")"}
		    </div>
		  }
		</p>
	      </div>
	    </div>
	    <div>
	      {errors.confidential && <div className="c-errors">
		{t('text_editor_confidential_mandatory')}
              </div>}
	    </div>
	  </div>
        </div>
      </div>
      }
    </>
  )
}

export default TagsContent
